import { ImageBackground, StyleSheet, Text, View } from 'react-native';

import { MyTablesButtonBg, TournamentsButtonBg } from '../../../../assets';
import { testProps } from '../../../../config';
import { TouchableOpacity } from '../../common/Touchable';

type TournamentMobileNavProps = {
	activeTablesLabel: string;
	onMyTablesPress: () => void;
	onTournamentStatsPress: () => void;
	scaleSize: (value: number) => number;
	tournamentsLabel: string;
	width: number;
};

const TournamentMobileNav = ({
	activeTablesLabel,
	onMyTablesPress,
	onTournamentStatsPress,
	scaleSize,
	tournamentsLabel,
	width,
}: TournamentMobileNavProps) => {
	const styles = createStyles(scaleSize, width);
	return (
		<View style={styles.mobileTournamentNavWrap}>
			<View style={styles.mobileRow}>
				<TouchableOpacity
					style={styles.mobileButton}
					onPress={onMyTablesPress}
					{...testProps('cta-tournament-my-tables')}
				>
					<ImageBackground
						source={MyTablesButtonBg}
						style={styles.mobileButtonBackground}
						resizeMode='stretch'
					>
						<View style={styles.mobileButtonContent}>
							<Text style={styles.tournamentFooterTextMobile}>{activeTablesLabel}</Text>
						</View>
					</ImageBackground>
				</TouchableOpacity>

				<TouchableOpacity
					style={styles.mobileButton}
					onPress={onTournamentStatsPress}
					{...testProps('cta-tournament-stats')}
				>
					<ImageBackground
						source={TournamentsButtonBg}
						style={styles.mobileButtonBackground}
						resizeMode='stretch'
					>
						<View style={styles.mobileButtonContent}>
							<Text style={[styles.tournamentFooterTextMobile, styles.tournamentFooterTextGold]}>
								{tournamentsLabel}
							</Text>
						</View>
					</ImageBackground>
				</TouchableOpacity>
			</View>
		</View>
	);
};

const createStyles = (scaleSize: (value: number) => number, width: number) =>
	StyleSheet.create({
		mobileTournamentNavWrap: {
			width: '100%',
			alignItems: 'center',
			zIndex: 1,
			elevation: 1,
		},
		mobileRow: {
			flexDirection: 'row',
			width: '100%',
			height: scaleSize(width * 0.12),
		},
		mobileButton: {
			width: width / 2,
			height: '100%',
			justifyContent: 'center',
			alignItems: 'center',
			zIndex: 5,
		},
		mobileButtonBackground: {
			flex: 1,
			width: '100%',
			height: '100%',
		},
		mobileButtonContent: {
			flex: 1,
			justifyContent: 'center',
			alignItems: 'center',
		},
		tournamentFooterTextMobile: {
			width: '100%',
			color: 'white',
			fontWeight: 800,
			textTransform: 'uppercase',
			fontSize: scaleSize(16),
			textAlign: 'center',
		},
		tournamentFooterTextGold: {
			color: '#423113',
		},
	});

export default TournamentMobileNav;
